
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Pencil, Trash2 } from 'lucide-react';

interface SortableCardProps {
  card: {
    id: string;
    title: string;
    description: string;
    checked: boolean;
    editable?: boolean;
    canDelete?: boolean;
    prompt?: string;
  };
  handleEditCard: (card: any) => void;
  handleDeleteCard: (card: any) => void;
  setTemplateCards: (cards: any) => void;
  templateCards: any;
}

export function SortableCard({ card, handleEditCard, handleDeleteCard, setTemplateCards, templateCards }: SortableCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: card.id });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: transform ? 1 : 0,
  };
  
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Card className="flex flex-col items-start p-4 hover:shadow-md transition-shadow h-32 min-h-32">
        <div className="flex items-start w-full flex-1">
          <Checkbox 
            id={`section${card.id}`}
            className="mt-1 mr-3 flex-shrink-0"
            checked={card.checked}
            onCheckedChange={(checked) => {
              const updatedSections = templateCards.sections.map((s: any) => 
                s.id === card.id ? {...s, checked: !!checked} : s
              );
              setTemplateCards({...templateCards, sections: updatedSections});
            }}
          />
          <div className="flex-grow min-w-0">
            <Label htmlFor={`section${card.id}`} className="font-semibold text-sm block">
              {card.title}
            </Label>
            <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
              {card.description}
            </p>
          </div>
          <div className="flex space-x-2 ml-2 flex-shrink-0">
            <button 
              className="text-muted-foreground hover:text-foreground transition-colors p-1 bg-transparent border-none cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                handleEditCard(card);
              }}
            >
              <Pencil className="h-4 w-4" />
            </button>
            <button 
              className="text-muted-foreground hover:text-destructive transition-colors p-1 bg-transparent border-none cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteCard(card);
              }}
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
